// extracted by mini-css-extract-plugin
module.exports = {"shadow":"ClickableLink_shadow__3QHO3","link":"ClickableLink_link__2ZDmY"};